module.exports = __webpack_public_path__ + "img/006.ec09c484.png";